import React, { Fragment, useRef } from 'react';
import {
  Form,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  FormFeedback,
  FormText,
} from 'reactstrap';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useState } from 'react';
import ADDITIONAL_DOCUMENTS from './ADDITIONAL_DOCUMENTS';
import { bindActionCreators } from 'redux';
import {
  DOCUMENT_GOTO_NEXT_STEP,
  SET_AND_RESET_ADDITIONAL_DOCUMENTS,
  SET_DOCUMENT_FORM_AS_EDITABLE,
  SET_DOCUMENT_TYPE,
  SET_DOCUMENT_FORMAT,
  GOTO_SELECTED_STEP,
} from '../../../redux/actions/ActionTypes';
import { connect } from 'react-redux';
import {
  authHeader,
  loggedUserDetails,
} from '../../../utils/functions/CoreFunctions';
import {
  AGENCY_DOCUMENT_CREATE_URL,
  AGENCY_DOCUMENT_UPDATE_URL,
  AGENCY_DOCUMENT_CHECK_HYPERLINK_AVAILABLE_URL,
  AGENCY_DOCUMENT_DETAILS_URL,
  GET_LOCATION_CODE,
} from '../../../utils/APIEndpoints';
import Swal from 'sweetalert2';
import {
  getAlert,
  getAlertToast,
  SingleStringFirstLetterCaps,
} from '../../../utils/functions/CustomFunctions';
import API from '../../../redux/actions/API';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { debounce } from 'underscore';
import {
  FLOAT_REGEX,
  NUMBER_REGEX,
} from '../../../utils/constants/ValidationRegexs';
import VariablesList from './VariablesList';
import { DOCUMENTS_PATH } from '../../../utils/AppRoutes';
import { getLocationCodeList } from '../../../redux/actions';

import ReactQuill, { Quill } from 'react-quill';

var Link = Quill.import('formats/link');
var builtInFunc = Link.sanitize;

Link.sanitize = function customSanitizeLinkInput(linkValueInput) {
  var val = linkValueInput;

  // do nothing, since this implies user's already using a custom protocol
  if (/^\w+:/.test(val));
  else if (!/^https?:/.test(val)) val = 'http://' + val;

  return builtInFunc.call(this, val); // retain the built-in logic
};

//Validation Schema
const validationSchema = Yup.object({
  paymentType: Yup.string().trim().required('Document type is required'),
  serviceName: Yup.string().trim().required('Document label is required'),
  documentType: Yup.string().trim().required('Document Format is required'),
  serviceDomainURL: Yup.string()
    .trim()
    .required('Document Hyperlink is required'),
  serviceAmount: Yup.number().when('paymentType', {
    is: 'Fixed',
    then: Yup.number()
      .required('Fee is required')
      .min(0, 'Please give valid fee'),
    otherwise: Yup.number().notRequired(),
  }),
  locationCodeId: Yup.string().trim().required('Location Code is required'),
});

var modules = {
  // toolbar: [
  //   ['bold', 'italic', 'underline', 'strike'], // toggled buttons
  //   ['blockquote', 'code-block'],

  //   [{ header: 1 }, { header: 2 }], // custom button values
  //   [{ list: 'ordered' }, { list: 'bullet' }],
  //   [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
  //   [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
  //   [{ direction: 'rtl' }], // text direction

  //   [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
  //   [{ header: [1, 2, 3, 4, 5, 6, false] }],

  //   [{ color: [] }, { background: [] }], // dropdown with defaults from theme
  //   [{ font: [] }],
  //   [{ align: [] }],

  //   ['link'], //link button
  //   ['clean'], // remove formatting button
  // ],
  // },
  toolbar: {
    // handlers: {
    //   // link: function (value) {

    //   // },

    // },
    container: [
      ['bold', 'italic', 'underline', 'strike'], // toggled buttons
      ['blockquote', 'code-block'],

      [{ header: 1 }, { header: 2 }], // custom button values
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
      [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
      [{ direction: 'rtl' }], // text direction

      [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
      [{ header: [1, 2, 3, 4, 5, 6, false] }],

      [{ color: [] }, { background: [] }], // dropdown with defaults from theme
      [{ font: [] }],
      [{ align: [] }],

      ['link'], //link button
      ['clean'], // remove formatting button
    ],
    // clipboard: {
    //   matchVisual: false,
    // },
    // bounds: document.body,
  },
};

function STEP_ONE_BASIC_DETAILS(props) {
  const history = useHistory();
  const {
    dispatch,
    CreateDocumentForm = {},
    HandleDocumentType = {},
    HandleDocumentFormat = {},
    VariantsListReducer = {},
    LocationCodeListReducer = {},
    setSubmitLoading,
  } = props;
  const [additionalDocumentFlag, setAdditionalDocumentFlag] = useState(false);
  const { step1 = {}, agencyServiceId = '', currentStep } = CreateDocumentForm;
  const { additionalDocuments = [], formInitialValues = {} } = step1;
  const { paymentsType = '' } = HandleDocumentType;
  const { documentsType = '' } = HandleDocumentFormat;
  const { data: variableList = [] } = VariantsListReducer;
  const { data: locationCodes = [] } = LocationCodeListReducer;
  //State
  const [isUrlAvailable, setURLAvailableFlag] = useState(true);
  const [loading, setLoading] = useState(false);
  const { agencyId, userId } = loggedUserDetails();
  useEffect(() => {
    if (additionalDocuments.length > 0) {
      setAdditionalDocumentFlag(true);
    } else if (additionalDocuments.length == 0) {
      setAdditionalDocumentFlag(false);
    }
  }, [additionalDocuments.length]);

  const getDocumentDetails = async (id) => {
    try {
      const options = {
        method: 'GET',
        url: AGENCY_DOCUMENT_DETAILS_URL,
        headers: authHeader(),
        params: { agencyServiceId: parseInt(id) },
      };
      const response = await API(options);
      let apiResponse = response.data;
      const { status } = apiResponse;
      if (status === 'Success') {
        const {
          status: documentStatus = '',
          paymentType = '',
          documentType = '',
        } = apiResponse.data;
        dispatch({
          type: SET_DOCUMENT_TYPE,
          payload: paymentType,
        });
        dispatch({
          type: SET_DOCUMENT_FORMAT,
          payload: documentType,
        });
        dispatch({
          type: SET_DOCUMENT_FORM_AS_EDITABLE,
          payload: apiResponse.data,
          moveToStep:
            values.paymentType === 'Variable'
              ? 2
              : values.paymentType === 'Fixed' && values.documentType === 'Pdf'
              ? 3
              : values.paymentType === 'Fixed' &&
                values.documentType === 'WebForm'
              ? 3
              : 5,
        });
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
      }
    }
  };

  const makeCaptialiaztion = (str) => {
    var splitStr = str.split(' ');
    for (var i = 0; i < splitStr.length; i++) {
      splitStr[i] =
        splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(' ');
  };

  useEffect(() => {
    dispatch(
      getLocationCodeList({
        agencyId: agencyId,
      })
    );
  }, []);

  //Form Submit
  const saveFormValues = async (values) => {
    const documentFee = values.serviceAmount || 0;
    values.serviceAmount = documentFee;
    values.agencyId = parseInt(agencyId);
    values.createdBy = parseInt(userId);
    values.isSubmitAdmin = false;
    values.requiredDocuments = additionalDocumentFlag
      ? JSON.stringify(additionalDocuments)
      : '[]';
    values.agencyServiceId = agencyServiceId
      ? parseInt(agencyServiceId)
      : undefined;
    try {
      setSubmitLoading(true);
      const options = {
        method: agencyServiceId ? 'PUT' : 'POST',
        url: agencyServiceId
          ? AGENCY_DOCUMENT_UPDATE_URL
          : AGENCY_DOCUMENT_CREATE_URL,
        headers: authHeader(),
        data: values,
      };
      Swal.fire(getAlertToast('success', 'Please wait...'));
      var apiResponse = await API(options);
      const { status, message } = apiResponse.data;
      if (status === 'Error') {
        Swal.fire(getAlertToast('error', message));
      } else {
        let alertMsg = agencyServiceId
          ? 'Document details updated successfully'
          : 'New document added successfully. You may update and continue.';
        Swal.fire(getAlertToast('success', alertMsg));
        dispatch({
          type: SET_DOCUMENT_TYPE,
          payload: values.paymentType,
        });
        dispatch({
          type: SET_DOCUMENT_FORMAT,
          payload: values.documentType,
        });

        if (!agencyServiceId) {
          history.push({
            pathname: `/edit-document/${apiResponse.data.agencyServiceId}`,
            state: {
              moveToStep:
                values.paymentType === 'Variable'
                  ? 2
                  : values.paymentType === 'Fixed' &&
                    values.documentType === 'Pdf'
                  ? 3
                  : values.paymentType === 'Fixed' &&
                    values.documentType === 'WebForm'
                  ? 3
                  : 5,
            },
          });
          getDocumentDetails(agencyServiceId);

          //  getDocumentDetails(apiResponse.data.agencyServiceId);
        } else {
          getDocumentDetails(agencyServiceId);
        }
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        Swal.fire(getAlertToast('error', data.message));
      }
    } finally {
      setSubmitLoading(false);
    }
  };

  //Additional Document Toggle
  const additioanlDocumentToggle = ({ target: { checked } }) => {
    setAdditionalDocumentFlag(checked);
    dispatch({
      type: SET_AND_RESET_ADDITIONAL_DOCUMENTS,
      payload: checked,
    });
  };

  //Formik
  const {
    setFieldValue,
    handleSubmit,
    handleChange,
    values,
    errors,
    touched,
    setFieldTouched,
    setFieldError,
  } = useFormik({
    initialValues: formInitialValues,
    enableReinitialize: true,
    validationSchema,
    onSubmit: (values) => saveFormValues(values),
  });

  //Create Random URL
  const generateRandomURL = () => {
    let hyperlink = Date.now();
    if (hyperlink) delayedQuery(hyperlink);
    setFieldValue('serviceDomainURL', hyperlink);
  };

  //Check Link Available
  const checkHyperlinkIsAvailable = async (givenLink) => {
    try {
      setLoading(true);
      const options = {
        method: 'POST',
        url: AGENCY_DOCUMENT_CHECK_HYPERLINK_AVAILABLE_URL,
        headers: authHeader(),
        data: { serviceDomainURL: givenLink },
      };
      const response = await API(options);
      let apiResponse = response.data;
      //
      const { status } = apiResponse;
      if (status === 'Success') setURLAvailableFlag(true);
      else {
        setURLAvailableFlag(false);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        // Swal.fire(getAlert('error',data.message));
      }
    } finally {
      setLoading(false);
    }
  };

  const {
    serviceName = '',
    serviceDescription = '',
    serviceDomainURL = '',
    serviceAmount = '',
    paymentType = '',
    documentType = '',
    locationCodeId = '',
  } = values;

  //Debounce
  const delayedQuery = useRef(
    debounce(
      (serviceDomainURL) => checkHyperlinkIsAvailable(serviceDomainURL),
      300
    )
  ).current;

  //Onchange URL Fiels
  const changeHyperlinkField = ({ target: { name, value } }) => {
    if (value) delayedQuery(value);
    setFieldValue('serviceDomainURL', value);
  };

  const onDescriptionChange = (e) => {
    setFieldValue(
      'serviceDescription',
      e.replace(/<(.|\n)*?>/g, '') == '' ? '' : e
    );
  };

  return (
    <Fragment>
      <Form form="true" onSubmit={handleSubmit} id="form_step_1">
        <Row form>
          <Col md={12}>
            <FormGroup>
              <Label for="serviceName">
                Document Label <span className="required-labels">*</span>
              </Label>
              <Input
                type="text"
                name="serviceName"
                id="serviceName"
                placeholder="Enter Document Label"
                invalid={
                  errors.serviceName && touched.serviceName ? true : false
                }
                onChange={handleChange}
                // onChange={({ target: { value } }) => {
                //   setFieldTouched("serviceName", true);
                //   setFieldValue("serviceName", makeCaptialiaztion(value));
                // }}
                value={serviceName}
              />
              <FormFeedback>
                {errors.serviceName && touched.serviceName
                  ? errors.serviceName
                  : ''}
              </FormFeedback>
            </FormGroup>
          </Col>
          {/* <Col md={6}>
            <FormGroup>
              <Label for="serviceDescription">Description</Label>
              <Input
                type="textarea"
                name="serviceDescription"
                id="serviceDescription"
                placeholder="Enter Description"
                value={serviceDescription}
                onChange={handleChange}
              />
            </FormGroup>
          </Col> */}
          <Col md={12}>
            <FormGroup>
              <Label for="serviceDescription">Description</Label>
              <ReactQuill
                theme="snow"
                type="textarea"
                className="formatter-containter"
                name="serviceDescription"
                id="serviceDescription"
                placeholder="Enter Description"
                value={serviceDescription}
                onChange={(e) => onDescriptionChange(e)}
                modules={modules}
              />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <Label for="serviceDomainURL">
                Hyperlink <span className="required-labels">*</span>
              </Label>
              <Input
                type="text"
                name="serviceDomainURL"
                id="serviceDomainURL"
                placeholder="Enter Hyperlink"
                invalid={
                  errors.serviceDomainURL && touched.serviceDomainURL
                    ? true
                    : false
                }
                onChange={(event) => {
                  setFieldTouched('serviceDomainURL', true);
                  changeHyperlinkField(event);
                }}
                value={serviceDomainURL}
              />
              <FormFeedback>
                {errors.serviceDomainURL && touched.serviceDomainURL
                  ? errors.serviceDomainURL
                  : ''}
              </FormFeedback>
              <FormFeedback>
                {errors.serviceDomain ? errors.serviceDomain : ''}
              </FormFeedback>

              {serviceDomainURL && (
                <Fragment>
                  {isUrlAvailable ? (
                    <p style={{ color: '#057318' }}>Hyperlink available</p>
                  ) : (
                    <p style={{ color: '#DC3545' }}>Hyperlink already in use</p>
                  )}
                </Fragment>
              )}
              <FormText
                color="muted"
                onClick={generateRandomURL}
                style={{
                  cursor: 'pointer',
                  textDecoration: 'underline',
                  width: 'fit-content',
                }}
              >
                Generate Random Link
              </FormText>
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <Label for="serviceAmount">Document Fee ($)</Label>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>$</InputGroupText>
                </InputGroupAddon>
                <Input
                  type="text"
                  name="serviceAmount"
                  id="serviceAmount"
                  placeholder="Enter Document Fee"
                  invalid={
                    errors.serviceAmount && touched.serviceAmount ? true : false
                  }
                  onChange={(event) => {
                    setFieldTouched('serviceAmount', true);
                    handleChange(event);
                  }}
                  value={serviceAmount}
                />
                <FormFeedback>
                  {errors.serviceAmount && touched.serviceAmount
                    ? errors.serviceAmount
                    : ''}
                </FormFeedback>
              </InputGroup>
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <Label for="location code">
                Location Code <span className="required-labels">*</span>
              </Label>
              <Input
                type="select"
                name="locationCodeId"
                id="locationCodeId"
                invalid={
                  errors.locationCodeId && touched.locationCodeId ? true : false
                }
                onChange={(event) => {
                  setFieldTouched('locationCodeId', true);
                  handleChange(event);
                }}
                value={locationCodeId}
              >
                <option value="">------ Select Location Code -------</option>
                {locationCodes &&
                  locationCodes.map((record, index) => {
                    const { locationCode, description } = record;
                    return (
                      <option value={locationCode} key={`list_${index}`}>
                        {locationCode + ' ' + (description || 'N/A')}
                      </option>
                    );
                  })}
              </Input>
              <FormFeedback>
                {errors.locationCodeId && touched.locationCodeId
                  ? errors.locationCodeId
                  : ''}
              </FormFeedback>
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label for="paymentType">
                Document Type <span className="required-labels">*</span>
              </Label>
              <Input
                type="select"
                name="paymentType"
                id="paymentType"
                invalid={
                  errors.paymentType && touched.paymentType ? true : false
                }
                onChange={(event) => {
                  setFieldTouched('paymentType', true);
                  handleChange(event);
                }}
                value={paymentType}
              >
                <option value="">------ Select Document Type -------</option>
                <option value="Fixed">Fixed</option>
                <option value="Variable">Variable</option>
                {/* <option value="WebForm">WebForm</option> */}
              </Input>
              <FormFeedback>
                {errors.paymentType && touched.paymentType
                  ? errors.paymentType
                  : ''}
              </FormFeedback>
            </FormGroup>
          </Col>

          <Col md={6}>
            <FormGroup>
              <Label for="documentType">
                Document Format <span className="required-labels">*</span>
              </Label>
              <Input
                type="select"
                name="documentType"
                id="documentType"
                invalid={
                  errors.documentType && touched.documentType ? true : false
                }
                onChange={(event) => {
                  setFieldTouched(' documentType', true);
                  handleChange(event);
                }}
                value={documentType}
              >
                <option value="">
                  ------ Select Document Format Type -------
                </option>
                <option value="Pdf">PDF</option>
                <option value="WebForm">WEBFORM</option>
                {/* <option value="WebForm">WebForm</option> */}
              </Input>
              <FormFeedback>
                {errors.documentType && touched.documentType
                  ? errors.documentType
                  : ''}
              </FormFeedback>
            </FormGroup>
          </Col>

          <Col md={12}>
            <FormGroup check>
              <Label check>
                <Input
                  style={{ cursor: 'pointer' }}
                  name="additionalDocumentFlag"
                  type="checkbox"
                  onChange={additioanlDocumentToggle}
                  value={additionalDocumentFlag}
                  checked={additionalDocumentFlag}
                />
                Need Additional Documents?
              </Label>
            </FormGroup>
          </Col>
          <br />
          <br />
          {additionalDocumentFlag && (
            <Col md={12}>
              <ADDITIONAL_DOCUMENTS />
            </Col>
          )}
        </Row>
      </Form>
    </Fragment>
  );
}
const getState = ({
  CreateDocumentForm,
  HandleDocumentType,
  HandleDocumentFormat,
  VariantsListReducer,
  LocationCodeListReducer,
}) => {
  return {
    CreateDocumentForm,
    HandleDocumentType,
    HandleDocumentFormat,
    VariantsListReducer,
    LocationCodeListReducer,
  };
};
const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(
    {
      getLocationCodeList,
    },
    dispatch
  ),
  dispatch,
});

export default connect(getState, mapDispatchToProps)(STEP_ONE_BASIC_DETAILS);
